import { GetServerSideProps } from 'next'
import Login from 'components/auth/Login'
import React from 'react'
import { faUserPlus } from '@fortawesome/pro-regular-svg-icons'
import language from 'services/Language'
import Link from 'next/link'
import Button from 'components/Button'
import {
  useResolveSubdomainQuery,
  useBaseCollectiveQuery
} from 'graphql/generated'
import { useSubdomain } from 'lib/subdomainUtils'

interface IProps {
  email: string
  password: string
}

function LoginPage({ email, password }: IProps) {
  const subdomain = useSubdomain()
  const { data: { resolveSubdomain } = {} } = useResolveSubdomainQuery({
    variables: { slug: subdomain! },
    skip: !subdomain
  })
  const combinedCollectiveId =
    resolveSubdomain?.__typename === 'Collective' ? resolveSubdomain.id : null
  const { data: { collective } = {} } = useBaseCollectiveQuery({
    variables: {
      collectiveId: combinedCollectiveId!
    },
    skip: !combinedCollectiveId
  })

  return (
    <div className="flex flex-col min-h-[100vh] bg-gray-50">
      <div className="flex items-center justify-center flex-col flex-1 flex-shrink-0">
        <div className="w-full sm:w-[400px] flex">
          <Login
            defaultEmail={email}
            defaultPassword={password}
            collective={collective}
          />
        </div>

        <div className="mt-4">
          <Link href="/auth/signup" passHref>
            <Button
              label={language.common.signup}
              icon={faUserPlus}
              color="textOnly"
              iconPlacement="after"
            />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default LoginPage

export const getServerSideProps: GetServerSideProps<IProps> = async () => {
  return {
    props: {
      email: process.env.DEFAULT_LOGIN_USER || '',
      password: process.env.DEFAULT_LOGIN_PASSWORD || ''
    }
  }
}
